import { OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Data } from '../../helpers';
import { DashboardService } from '../../dashboard';
import { LoginService } from '../../login';
import { ErrorHandlerService } from '../../services';
var AllProfileVisitsComponent = /** @class */ (function () {
    function AllProfileVisitsComponent(data, dashboardService, errorHandlerService, loginService, route, router) {
        this.data = data;
        this.dashboardService = dashboardService;
        this.errorHandlerService = errorHandlerService;
        this.loginService = loginService;
        this.route = route;
        this.router = router;
        this.user = {};
        this.query = {};
        this.uid = {};
        this.rating = { responseTo: {}, responseFrom: {}, rating: {} };
        this.reqRcmd = { requestTo: {}, requestFrom: {} };
        this.myConnection = [];
        this.mynetworkcheck = "false";
        this.eduInstresults = [];
        this.eduInst = [];
        this.connectionfilter = {};
        this.countries = [];
        this.sendMsg = false;
        this.viewProfile = {};
        this.msgData = {};
        this.invitereq = { requestTo: {}, requestFrom: {} };
        this.showSpinner = false;
        this.showOnlyOverlay = false;
        this.showErrorModalDialog = false;
        this.showErrorMessages = [""];
        this.showErrorMessageTitle = "Error!";
        this.showErrorMessageWidthInPercentage = "20%";
        this.subscriptions = [];
        this.isSessionExpired = false;
        this.showLoadMoreBtn = true;
    }
    AllProfileVisitsComponent.prototype.rcmdReq = function () {
        var _this = this;
        this.reqRcmd.userRequestType = 'RECOMMENDATION_REQUEST';
        var s7 = this.dashboardService.rcmdRequest(this.reqRcmd).subscribe(function (data) {
            _this.request = false;
            _this.reqRcmd.userRequestText = '';
            _this.createInfoAlert("Successfully sent Recommendation Request !!");
        }, function (error) {
            _this.request = false;
            _this.reqRcmd.userRequestText = '';
            _this.handleError(error);
        });
        this.subscriptions.push(s7);
    };
    AllProfileVisitsComponent.prototype.acceptconReq = function (id, searchResult) {
        var _this = this;
        var s1 = this.dashboardService.connAccept(id).subscribe(function (data) {
            console.log(data);
            searchResult.invitationAction = 'In My Network';
            searchResult.studentsCount = data.requestFrom.studentConnectionCount;
            searchResult.professorsCount = data.requestFrom.professorConnectionCount;
            searchResult.alumniCount = data.requestFrom.alumniConnectionCount;
            searchResult.ratingAction = 'SEND_RATING';
            _this.showSpinner = false;
            _this.createInfoAlert("Successfully accepted Invitation Request !!");
        }, function (error) {
            _this.handleError(error);
        });
        this.subscriptions.push(s1);
    };
    AllProfileVisitsComponent.prototype.ratingUser = function (connection) {
        var _this = this;
        this.showSpinner = true;
        this.rating.userResponseType = 'RATING_RESPONSE';
        var s2 = this.dashboardService.rating(this.rating).subscribe(function (data) {
            console.log(data);
            _this.rating.rating.ratingText = "";
            _this.rating.responseTo.userDetailsId = '';
            connection.ratingAction = 'RATING_ALREADY_SENT';
            _this.showSpinner = false;
            _this.createInfoAlert("Rating submitted successfully!!");
        }, function (error) {
            _this.showSpinner = false;
            _this.rating.rating.ratingText = "";
            _this.rating.responseTo.userDetailsId = '';
            _this.handleError(error);
        });
        this.subscriptions.push(s2);
    };
    AllProfileVisitsComponent.prototype.searcheduinst = function (event) {
        this.eduInstresults = this.filtereduins(event.query, this.eduInst);
    };
    AllProfileVisitsComponent.prototype.filtereduins = function (query, eduInst) {
        //in a real application, make a request to a remote url with the query and return filtered results, for demo we filter at client side
        var filtered = [];
        for (var i = 0; i < eduInst.length; i++) {
            var eduinst = eduInst[i];
            if (eduinst.educationalInstitutionFullName != null) {
                if (eduinst.educationalInstitutionFullName.toLowerCase().indexOf(query.toLowerCase()) == 0) {
                    filtered.push(eduinst.educationalInstitutionFullName);
                }
            }
        }
        return filtered;
    };
    AllProfileVisitsComponent.prototype.myNetworkCheck = function (event) {
        if (event.target.checked) {
            this.connectionfilter.inMyNetworkFilterCriteria = "true";
            this.getSearchData();
        }
    };
    AllProfileVisitsComponent.prototype.awaitResCheck = function (event) {
        if (event.target.checked) {
            this.connectionfilter.awaitingResponseFilterCriteria = "true";
            this.getSearchData();
        }
    };
    AllProfileVisitsComponent.prototype.professorsCheck = function (event) {
        if (event.target.checked) {
            this.connectionfilter.professors = "true";
            this.getSearchData();
        }
    };
    AllProfileVisitsComponent.prototype.studentsCheck = function (event) {
        if (event.target.checked) {
            this.connectionfilter.students = "true";
            this.getSearchData();
        }
    };
    AllProfileVisitsComponent.prototype.alumniCheck = function (event) {
        if (event.target.checked) {
            this.connectionfilter.alumni = "true";
            this.getSearchData();
        }
    };
    AllProfileVisitsComponent.prototype.editDisplay = function (edit) {
        if (edit) {
            return "block";
        }
        else {
            return "none";
        }
    };
    AllProfileVisitsComponent.prototype.myConnectionLoadM = function () {
        var _this = this;
        var s3 = this.dashboardService.allProfileVisitsLoadMore(this.connectionfilter).subscribe(function (data) {
            data.forEach(function (element) {
                _this.myConnection.push(element);
            });
        }, function (error) {
            //this.showLoadMoreBtn = false;
            _this.handleError(error);
        });
        this.subscriptions.push(s3);
    };
    AllProfileVisitsComponent.prototype.sendInvite = function (id) {
        var _this = this;
        this.invitereq.requestTo.userDetailsId = id;
        this.invitereq.userRequestText = "Invitation Request sent by User Id " + this.invitereq.requestTo.userDetailsId + " to User Id " + id + ". Sent by REST Service.";
        this.invitereq.userRequestType = 'INVITATION_REQUEST';
        var s4 = this.dashboardService.sendInvitationReq(this.invitereq).subscribe(function (data) {
            _this.getSearchData();
        }, function (error) { console.log(error); _this.handleError(error); });
        this.createInfoAlert('Your connection request has been sent.');
        this.subscriptions.push(s4);
    };
    AllProfileVisitsComponent.prototype.sendMssage = function (data) {
        this.viewProfile = data;
        this.msgData.usersInTo = [data.userDetailsId];
        this.sendMsg = true;
    };
    AllProfileVisitsComponent.prototype.sendMessage = function () {
        var _this = this;
        var s5 = this.dashboardService.inboxSendMsg(this.msgData).subscribe(function (data) {
            _this.sendMsg = false;
            _this.msgData.messageSubject = '';
            _this.msgData.messageBody = '';
            _this.createInfoAlert('Message sent successfully !!');
            console.log(data);
        }, function (error) {
            _this.sendMsg = false;
            _this.msgData.messageSubject = '';
            _this.msgData.messageBody = '';
            _this.handleError(error);
        });
        this.subscriptions.push(s5);
    };
    AllProfileVisitsComponent.prototype.ngOnInit = function () {
        var _this = this;
        //console.log('inside ngOnInit()');
        var s6 = this.dashboardService.userSummary1().subscribe(function (data) {
            _this.user = data;
            _this.rating.responseFrom.userDetailsId = _this.user.userDetailsId;
            _this.reqRcmd.requestFrom.userDetailsId = _this.user.userDetailsId;
            _this.invitereq.requestFrom.userDetailsId = _this.user.userDetailsId;
        }, function (error) { _this.handleError(error); });
        this.subscriptions.push(s6);
        var s7 = this.route.queryParams.subscribe(function (params) {
            _this.query = params['s'] || 0;
            _this.uid = params['u'] || 0;
            if (_this.query == '0') {
                _this.loginService.eduins().subscribe(function (data) { _this.eduInst = data; }, function (error) { console.log(error); _this.handleError(error); });
                _this.loginService.country().subscribe(function (data) {
                    _this.countries = data;
                    //console.log("this.countries..............."+JSON.stringify(this.countries));
                }, function (error) { _this.handleError(error); });
                _this.dashboardService.allProfileVisits(_this.connectionfilter).subscribe(function (data) { _this.myConnection = data; console.log(_this.myConnection); }, function (error) { _this.handleError(error); });
            }
            else {
                if (_this.query == 'student') {
                    _this.connectionfilter.students = "true";
                    if (_this.uid != 0) {
                        _this.connectionfilter.searchUserId = _this.uid;
                    }
                    _this.getSearchData();
                }
                if (_this.query == 'professor') {
                    _this.connectionfilter.professors = "true";
                    if (_this.uid != 0) {
                        _this.connectionfilter.searchUserId = _this.uid;
                    }
                    _this.getSearchData();
                }
                if (_this.query == 'alumni') {
                    _this.connectionfilter.alumni = "true";
                    if (_this.uid != 0) {
                        _this.connectionfilter.searchUserId = _this.uid;
                    }
                    _this.getSearchData();
                }
            }
        });
        this.subscriptions.push(s6);
    };
    AllProfileVisitsComponent.prototype.getSearchData = function () {
        var _this = this;
        return this.dashboardService.addConnections(this.connectionfilter).subscribe(function (data) { _this.myConnection = data; console.log(_this.myConnection); }, function (error) { _this.handleError(error); });
    };
    AllProfileVisitsComponent.prototype.onChange = function () {
        this.getSearchData();
    };
    AllProfileVisitsComponent.prototype.handleError = function (error) {
        var url = error.url;
        if (url == undefined) {
            return;
        }
        this.errorHandlerService.throwError(error);
    };
    AllProfileVisitsComponent.prototype.ngOnDestroy = function () {
        this.subscriptions.forEach(function (element) {
            element.unsubscribe();
        });
    };
    AllProfileVisitsComponent.prototype.createInfoAlert = function (alert) {
        var infoAlert = {
            isInfo: true,
            infoMessage: alert,
            url: "not required"
        };
        this.handleError(infoAlert);
    };
    return AllProfileVisitsComponent;
}());
export { AllProfileVisitsComponent };
//# sourceMappingURL=allprofilevisits.component.js.map